<div [hidden]="!includeLabel">
    <label for="{{name}}">{{labelName}}</label>
</div>
<div *ngIf="detailMode; then mostrarTexto else mostrarEntrada"></div>
<ng-template #mostrarTexto>
    <div [innerHtml]="obterTexto()"></div>
</ng-template>
<ng-template #mostrarEntrada>
    <div [formGroup]="quillFormGroup" class="form-quill">
        <quill-editor #field [placeholder]="placeholder" [required]="required" [formControlName]="'quilleditor'"
            [id]="(id === null ? name : id)" (onContentChanged)="atualizarForm($event)" [styles]="{'height': height}">
            <div quill-editor-toolbar>
                <span class="ql-formats">
                    <select class="ql-font" *ngIf="this.showFontFormat">
                        <option selected></option>
                        <option value="serif"></option>
                        <option value="monospace"></option>
                    </select>
                    <select class="ql-size" *ngIf="this.showFontFormat">
                        <option value="small">Pequeno</option>
                        <option selected></option>
                        <option value="large">Grande</option>
                        <option value="huge">Enorme</option>
                    </select>
                </span>
                <span class="ql-formats" *ngIf="this.showTextDecorators">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                    <button class="ql-strike"></button>
                </span>
                <span class="ql-formats" *ngIf="this.showFontFormat">
                    <select class="ql-color"></select>
                    <select class="ql-background"></select>
                </span>
                <span class="ql-formats">
                    <button class="ql-list" value="ordered" *ngIf="this.showListOptions"></button>
                    <button class="ql-list" value="bullet" *ngIf="this.showListOptions"></button>
                    <select class="ql-align" *ngIf="this.showAlignment">
                        <option selected></option>
                        <option value="center"></option>
                        <option value="right"></option>
                        <option value="justify"></option>
                    </select>
                </span>
                <span class="ql-formats">
                    <button class="ql-link" *ngIf="this.showHyperLink"></button>
                    <button class="ql-image" *ngIf="this.showAttachImage"></button>
                </span>
            </div>
        </quill-editor>
    </div>

</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>
